import { Button, Stack, Typography } from "@mui/material";
import React from "react";
import backImage from "../../../assets/lusoft-beta-bg.webp";
import config from "../../../config";
import { buttonClick } from "utils/googleAnalytics";

const NaradBeta = () => {
  return (
    <Stack sx={{ backgroundImage: `url(${backImage})`, px: 2 }}>
      <Stack
        flexDirection={"column"}
        justifyContent={"center"}
        alignItems={"center"}
        gap={3}
        sx={{ py: { xs: 10, sm: 12 } }}
      >
        <Stack justifyContent={"center"} alignItems={"center"}>
          <Typography
            sx={{
              fontFamily: "Comfortaa",
              display: "inline",
              fontSize: { xs: "35px", sm: "48px" },
              fontWeight: 700,
              lineHeight: { xs: "40px", sm: "60px" },
              color: (theme) => theme.palette.common.lightText,
              marginTop: 1,
              textAlign: "center",
            }}
          >
            lusoft
            <Typography
              component={"span"}
              sx={{
                fontFamily: "Oxygen",
                display: "inline",
                fontWeight: 700,
                fontSize: { xs: "35px", sm: "48px" },
                color: (theme) => theme.palette.common.lightText,
                lineHeight: { xs: "40px", sm: "60px" },
                ml: 1,
                textAlign: "center",
              }}
            >
              is in beta now and
            </Typography>
          </Typography>
        </Stack>
        <Stack>
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "35px", sm: "48px" },
              color: (theme) => theme.palette.common.white,
              lineHeight: { xs: "40px", sm: "60px" },
              marginTop: -3,
            }}
          >
            Free to use{" "}
          </Typography>
        </Stack>
        <Stack
          display={"flex"}
          flexDirection={"row"}
          justifyContent={"center"}
          alignItems={"center"}
          gap={1}
          px={2}
        >
          {/* <Typography
            sx={{
              fontSize: { xs: "20px", sm: "26px" },
              fontWeight: 400,
              lineHeight: "41.6px",
              textAlign: "center",
              color: (theme) => theme.palette.common.mediumText,
            }}
          >
            It will not take more then{" "}
            <Box
              sx={{
                fontWeight: 700,
                display: "inline",
                color: (theme) => theme.palette.primary.main,
              }}
            >
              5 min to setup
            </Box>
          </Typography> */}
        </Stack>
        <Button
          // onClick={() => {
          //   buttonClick({ buttonName: "Sign Up" });
          // }}
          variant="contained"
          size="large"
          // target="_blank"
          // href={config.signUpUrl}
          sx={{ px: 5.7, py: 2, borderRadius: "8px" }}
        >
          <Typography
            sx={{
              fontSize: "18px",
              fontWeight: 700,
              lineHeight: "27px",
            }}
          >
            Coming Soon
          </Typography>
        </Button>
      </Stack>
    </Stack>
  );
};

export default NaradBeta;
